export const warning = {
  state: {
    mails: '',
  },

  mutations: {
    setMailsWarning(state, error) {
      state.mails = error
    },

    clearMailsWarning(state) {
      state.mails = ''
    },
  },
}
